import React from 'react'
import Watsapp from "../../asset/images/icons/whatsapp.svg"
import FB from "../../asset/images/icons/fb.svg"
import Twitter from "../../asset/images/icons/twitter.svg"
import Linkedin from "../../asset/images/icons/linkedin.svg"
import Refer from "../../asset/images/refer.svg"
import ReferInfoTable from '../../Components/ReferEarn/ReferInfoTable'
import Header from '../../Components/Header'
import Sidebar from '../../Components/Sidebar'
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar'

function ReferEarn() {
    return (
        <>
            <Header/>
            {/* <Sidebar/> */}
            <SingleSignOnSideBar/>
            <main id="main-content" className="refer-earn">
                <div className="refer-head">
                    <h2 className="refer-head-title">Share your Referral Code</h2>
                    <ul className="nav nav-tabs filter-tabs" id="referTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="client-tab" data-bs-toggle="tab" data-bs-target="#client-tab-pane" type="button" role="tab" aria-controls="client-tab-pane" aria-selected="true">Client</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="cba-tab" data-bs-toggle="tab" data-bs-target="#cba-tab-pane" type="button" role="tab" aria-controls="cba-tab-pane" aria-selected="false">CBA</button>
                        </li>
                    </ul>
                </div>
                <div className="tab-content refer-tab-content" id="referTabContent">
                    <div className="tab-pane fade show active" id="client-tab-pane" role="tabpanel" aria-labelledby="client-tab" tabIndex={0}>
                        <div className="card-box code-card">
                            <div className="card-left">
                                <input type="text" className="input-st" placeholder="Add Email / Phone Number" />
                                <label htmlFor="user">Seperate Email with Commas</label>
                                <div className="btn-wrapper">
                                    <button className="invite-btn">Invite your Contacts</button>
                                    <button className="send-btn">Send</button>
                                </div>
                            </div>
                            <div className="card-right">
                                <div className="card-header">
                                    <h3 className="card-title">Client<span>&nbsp;Referral Link</span> </h3>
                                    <div className="copy-text">
                                        <input type="text" className="input-st" placeholder="http://www.Bajajfinserv/Client/Referral/CBA00976.ffgtrs" disabled />
                                        <div id="client-link">http://www.Bajajfinserv/Client/Referral/CBA00976.ffgtrs</div>
                                        <button className="copy-btn" onclick="copyToClipboard('#client-link')">Copy</button>
                                    </div>
                                </div>
                                <div className="socail-wrapper">
                                    <h4 className="socail-title">Share Via Social</h4>
                                    <ul className="socail-list">
                                        <li><a href="javacript:void(0)" className="whatsapp-txt"><img src={Watsapp} alt="" /><span>Whatsapp</span></a></li>
                                        <li><a href="javacript:void(0)" className="fb-txt"><img src={FB} alt="" /><span>Facebook</span></a></li>
                                        <li><a href="javacript:void(0)" className="twitter-txt"><img src={Twitter} alt="" /><span>Twitter</span></a></li>
                                        <li><a href="javacript:void(0)" className="linkedin-txt"><img src={Linkedin} alt="" /><span>Linkedin</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-box benifit-card">
                            <h4 className="card-heading card-title">Benefits</h4>
                            <h3 className="benefit-title">
                                Get <span> Rs 150</span> on every <br />
                                active referral &amp; also <br />
                                get <span> 25% Brokerage</span> Lifetime
                            </h3>
                            <div className="benefit-img"> <img src={Refer} alt="" /></div>
                        </div>
                        <div className="card-box info-card">
                            <div className="card-title">
                                <h2>Refer Info.</h2>
                            </div>
                            {/* <div className="expand-table collapsed-table"> */}
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Client ID</th>
                                            <th scope="col">Client Name</th>
                                            <th scope="col">Vertical</th>
                                            <th scope="col" className="text-center">Referral Earned</th>
                                            <th scope="col">Month</th>
                                            <th scope="col" className="text-center">Settlement</th>
                                            <th scope="col" className="text-center">Client Verification Status</th>
                                        </tr>
                                    </thead>
                            <ReferInfoTable/>
                                </table>
                            {/* </div> */}

                        </div>
                       
                    </div>

                    <div className="tab-pane fade" id="cba-tab-pane" role="tabpanel" aria-labelledby="cba-tab" tabIndex={0}>
                        <div className="card-box code-card">
                            <div className="card-left">
                                <input type="text" className="input-st" placeholder="Add Email / Phone Number" />
                                <label htmlFor="user">Seperate Email with Commas</label>
                                <div className="btn-wrapper">
                                    <button className="invite-btn">Invite your Contacts</button>
                                    <button className="send-btn">Send</button>
                                </div>
                            </div>
                            <div className="card-right">
                                <div className="card-header">
                                    <h3 className="card-title">CBA<span>&nbsp;Referral Link</span> </h3>
                                    <div className="copy-text">
                                        <input type="text" className="input-st" defaultValue="http://www.Bajajfinserv/CBA/Referral/CBA00976.ffgtrs" disabled />
                                        <div id="cba-link">http://www.Bajajfinserv/CBA/Referral/CBA00976.ffgtrs</div>
                                        <button className="copy-btn" onclick="copyToClipboard('#cba-link')">Copy</button>
                                    </div>
                                </div>
                                <div className="socail-wrapper">
                                    <h4 className="socail-title">Share Via Social</h4>
                                    <ul className="socail-list">
                                        <li><a href="javacript:void(0)" className="whatsapp-txt"><img src={Watsapp} alt="" /><span>Whatsapp</span></a></li>
                                        <li><a href="javacript:void(0)" className="fb-txt"><img src={FB} alt="" /><span>Facebook</span></a></li>
                                        <li><a href="javacript:void(0)" className="twitter-txt"><img src={Twitter} alt="" /><span>Twitter</span></a></li>
                                        <li><a href="javacript:void(0)" className="linkedin-txt"><img src={Linkedin} alt="" /><span>Linkedin</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-box benifit-card">
                            <h4 className="card-heading card-title">Benefits</h4>
                            <h3 className="benefit-title">
                                Get <span> Rs 1000</span> on every <br />
                                active referral &amp; also <br />
                                get <span> 10% Brokerage</span> Lifetime
                            </h3>
                            <div className="benefit-img"> <img src={Refer} alt="" /></div>
                        </div>
                        <div className="card-box info-card">
                            <div className="card-title">
                                <h2>Refer Info.</h2>
                            </div>
                            {/* <div className="expand-table collapsed-table"> */}
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">CBA ID</th>
                                            <th scope="col">CBA Name</th>
                                            <th scope="col">Vertical</th>
                                            <th scope="col" className="text-center">Referral Earned</th>
                                            <th scope="col">Month</th>
                                            <th scope="col" className="text-center">Settlement</th>
                                            <th scope="col" className="text-center">CBA Verification Status</th>
                                        </tr>
                                    </thead>
                                    <ReferInfoTable />

                                </table>

                            {/* </div> */}

                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}
export default ReferEarn